import { DatabaseOfferItem } from "../types/offers";

export const isSalesOrService = (offerSheetItem: DatabaseOfferItem) =>
  offerSheetItem?.details?.miraItemType === "SALES" ||
  offerSheetItem?.details?.miraItemType === "SERVICE";
